module.exports = __webpack_public_path__ + "static/img/btn-input-delete.45ba4a45.svg";